/*NEW TABS */
function showCollection(collectionId, element) {
    const parentEl = element.parentNode.parentNode;
    const parenColEl = element.parentNode;
    // Hide all home-product-slider-wrappers and remove 'selected' from all tabs
    parentEl.querySelectorAll('.home-product-slider-wrapper').forEach(function(wrapper) {
      wrapper.style.display = 'none';
    });
    parentEl.querySelectorAll('.tab-link').forEach(function(tab) {
      tab.classList.remove('selected');
    });
    console.log(parentEl)

    parentEl.querySelectorAll('.home-product-slider-cta').forEach((e)=>{
        e.style.display = 'none';
    })
  
    // Show the selected collection and mark the tab as 'selected'
    parentEl.querySelector('#collection-' + collectionId).style.display = 'flex';
    parentEl.querySelector('#CollectionCTA-' + collectionId).style.display = 'block';
    if(parentEl.querySelector('.slider-title > h2[data-change-title="true"] > span')) parentEl.querySelector('.slider-title > h2[data-change-title="true"] > span').textContent = element.textContent;
    element.classList.add('selected');
}

/* Slide arrow control */
function slide(el, direction) {
    const parentSection = el.parentNode.parentNode.parentNode;
    const visibleSliderWrapper = parentSection.classList.contains('home-info-slider') ? parentSection.querySelector('.home-info-slider-wrapper') : parentSection.querySelector('.home-product-slider-wrapper:not([style*="display: none"])')
    let scrollAmount;
    if(parentSection.classList.contains('home-info-slider') && window.innerWidth <= 750){
      scrollAmount = 300;
    }
    else{
      scrollAmount = parentSection.classList.contains('home-info-slider') ? 500 : 300;
    }
    
    if (!visibleSliderWrapper) return;

    if (direction === 'next') {
      visibleSliderWrapper.scrollLeft += scrollAmount;
    } else if (direction === 'prev') {
      visibleSliderWrapper.scrollLeft -= scrollAmount;
    }
}

function removeFirstQuickShop(){
  const mainElement = document.querySelector('body .mc_body > main');
  const children = Array.from(mainElement.children);

  children.forEach(child => {
    if (child.id !== "HpExpContent") {
      if (child.querySelector('.tag-cloud-container')){
        return;
      }
      mainElement.removeChild(child);
    }
  });
}